const homePageHeaderSlider = {
    _slider: null,
    timeout: null,
    delay: 250,

    init: function () {
        let self = this;

        window.initPackage('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js').then(function() {
            if(document.querySelector('.js-slider')) {
                self._sliderCreate();
            }
        })
        .catch(function(error) {
            console.error(error);
        });
    },

    _sliderCreate() {
        let self = this;
        
        self._slider = new Splide('.js-slider').mount();
        let slides = document.querySelectorAll('.js-slider .splide__slide');
        let array = [];
        
        slides.forEach((slide, index) => {
            array[index] = slide.clientHeight;
            
        });

        if(window.innerWidth >= 992) {
            self._slider.options = {
                type: 'loop',
                speed: 800,
                accessibility: true,
                arrows: false,
                keyboard: true,
                autoplay: true,
                pagination: true,
                direction: 'ttb',
                height: Math.max(...array),
            };
        }
        else {
            self._slider.options = {
                type: 'loop',
                speed: 800,
                accessibility: true,
                arrows: false,
                keyboard: true,
                autoplay: true,
                pagination: false,
            };
        }
        
        self._initClickEvent();

    },

    _initClickEvent() {
        let self = this;

        let nextButton = document.querySelector('.js-header-slider__nav-next');
        let prevButton = document.querySelector('.js-header-slider__nav-prev');

        if (nextButton) {
            nextButton.addEventListener('click', self._nextSlide, false);
        }

        if (prevButton) {
            prevButton.addEventListener('click', self._prevSlide, false);
        }

    },

    _nextSlide() {
        homePageHeaderSlider._slider.go('>');
    },

    _prevSlide() {
        homePageHeaderSlider._slider.go('<');
    },

    _goTo(self, index) {
        self._slider.go(index);
    },


    _destroyButtonsEvent() {
        let self = this;

        let nextButton = document.querySelector('.js-header-slider__nav-next');
        let prevButton = document.querySelector('.js-header-slider__nav-prev');

        if(!nextButton && !prevButton) {
            return;
        }

        
        nextButton.removeEventListener('click', self._nextSlide, false);
        prevButton.removeEventListener('click', self._prevSlide, false);
        
    },

    _destroy() {
        let self = this;
        self._slider.destroy();
        self._slider = null;
    },


    reInit() {
        let self = this;
        let node = document.querySelector('.js-slider');

        if (!node) {
            if (self._slider) {
                self._destroy();
            }

            return;
        }

        if (self._slider) {
            self._destroy();
        }

        self.init();
    },
};


window.homePageHeaderSlider = homePageHeaderSlider;

let slider = document.querySelector('.js-slider');
if (slider) {
    window.homePageHeaderSlider.init();

}

document.addEventListener('LokiRequestEnd', function () {
    window.homePageHeaderSlider.reInit();
});

var doit;
var prevWidth = window.innerWidth;

function resizedw(){
    if (window.innerWidth !== prevWidth ) {
        prevWidth = window.innerWidth;
        window.homePageHeaderSlider.reInit();
    }
}

window.addEventListener('resize', function() {
    // clear the timeout
    clearTimeout(doit);
    // start timing for event "completion"
    doit = setTimeout(resizedw, 250);
    
});


